/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { CustomSelect } from "../../../../../../../../_helpers/Helpers";

export function AbsenteeismDropdown({
  id,
  options,
  parentId,
  studentName,
  absenteeismValues,
  setAbsenteeismValues
}) {
  const [absenteeismStatus, setAbsenteeismStatus] = useState();
  const [explanation, setExplanation] = useState();
  const [isApplication, setIsApplication] = useState();
  const [isMail, setIsMail] = useState();
  const [isSms, setIsSms] = useState();

  useEffect(() => {
    const thisValue = absenteeismValues ? absenteeismValues.find(value => value.id === id) : undefined;
    const absenteeismStatus = thisValue ? thisValue.absenteeismStatus : null;
    const explanation = thisValue ? thisValue.explanation : null;
    const isApplication = thisValue ? thisValue.isApplication : null;
    const isMail = thisValue ? thisValue.isMail : null;
    const isSms = thisValue ? thisValue.isSms : null;
    setAbsenteeismStatus(absenteeismStatus);
    setExplanation(explanation);
    setIsApplication(isApplication);
    setIsMail(isMail);
    setIsSms(isSms);
  }, [id, absenteeismValues]);

  return (
    <CustomSelect
      options={options}
      value={absenteeismStatus}
      onBlur={e => e.currentTarget.closest("table").classList.add("overflow-hidden")}
      onFocus={e => e.currentTarget.closest("table").classList.remove("overflow-hidden")}
      onChange={option => {
        const otherValues = absenteeismValues.filter(value => value.id !== id);
        otherValues.push({ id, parentId, studentName, absenteeismStatus: option.value, explanation, isApplication, isMail, isSms });
        setAbsenteeismValues(otherValues);
      }}
    />
  );
}